import React, { useState } from 'react';
import { Modal, Button, Avatar, Input } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import axiosInstance from '../../axios';
import { dateDisplayable } from '../table-utils';
type TutorCommentsPopupProps = {
    cellValue: number | string;
    data: { shortlist_id: number; comment_count: string | number }
}

type CommentObjectType = {
    id: number;
    created_at: string;
    comment: string;
    admin_name: string;
};


function TutorCommentsPopup(props: TutorCommentsPopupProps) {
    const { shortlist_id, comment_count } = props?.data;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [commentsArray, setCommentsArray] = useState<CommentObjectType[]>([]);
    const [newComment, setNewComment] = useState('');
    const [loading, setLoading] = useState(false);

    const showModal = async () => {
        setLoading(true);
        await fetchCommentsArray();
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    async function fetchCommentsArray() {
        try {
            const { data } = await axiosInstance.get(`/v1/cre/student/recommendation/comments/${shortlist_id}`);
            console.log('The response data is ', data.data);
            setCommentsArray(data.data);

        } catch (error) {
            console.error('Error fetching comments:', error);
        } finally {
            setLoading(false);
        }
    }
    async function postNewComment(newComment: string) {
        if (!newComment)
            return;
        try {
            setLoading(true);
            const response = await axiosInstance.post(`/v1/cre/student/recommendation/comment`, {
                shortlist_id: shortlist_id,
                comment: newComment
            });
            console.log('Comment posted successfully:', response.data);
            setNewComment('');
            await fetchCommentsArray(); // Refresh the comments array after posting a new comment
        } catch (error) {
            console.error('Error posting comment:', error);
        } finally{
            setLoading(false);
        }
    }


    return (
        <div>
            <Button className="tail-mx-auto" type="primary" onClick={showModal} size="small" icon={<MessageOutlined />}>{comment_count}</Button>
            <Modal
                loading={loading}
                title="Tutor Comments"
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button key="close" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="ok" type='primary' onClick={() => postNewComment(newComment)}>
                        Ok
                    </Button>,
                ]}
            >
                <div className='tail-flex tail-flex-col tail-max-h-[400px] tail-gap-y-4 tail-overflow-y-scroll tail-mb-4'>
                    {commentsArray.map((comment) => (
                        <div key={comment.id} className='tail-flex tail-gap-x-4 tail-border-b last:tail-border-none tail-pb-4'>
                            <Avatar />
                            <div className='tail-grow'>
                                <div className='tail-flex tail-justify-between tail-w-full'>
                                    <h6>{comment.admin_name}</h6>
                                    <h6>{dateDisplayable(comment.created_at)}</h6>
                                </div>
                                <div>
                                    <p>{comment.comment}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div>
                    <Input placeholder='' value={newComment} onChange={(e) => setNewComment(e.target.value)} />
                </div>
            </Modal>
        </div>
    );
}

export default TutorCommentsPopup;